// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mimetika-login .language-selector{
    position: absolute;
    bottom: 10px;
    left: 10px;
}
.language-selector .p-hidden-accessible {
    display: none;
}
.language-dropdown {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
}
.language-selector .p-dropdown {
    background: transparent;
    border: none;
}
.language-selector .p-dropdown:hover span.p-dropdown-label{
    opacity: 1;
    text-decoration: underline;
}
.language-selector .p-dropdown span.p-dropdown-label {
    padding: 0;
    color: var(--blue);
    opacity: 0.8;
}
.language-selector .p-dropdown .p-dropdown-trigger {
    display: none !important;
}
.language-selector .p-dropdown:not(.p-disabled).p-focus{
    box-shadow: none;
}

.mimetika-dropdown-panel.p-dropdown-panel,
.language-selector-panel.p-dropdown-panel{
    background: var(--blue-dark);
    color: var(--gray);
}
.language-selector-panel.p-dropdown-panel {
    transform: translateX(33%) !important; /* Mueve el panel hacia la izquierda un 50% */
}


.mimetika-dropdown-panel.p-dropdown-panel .p-dropdown-items .p-dropdown-item,
.language-selector-panel.p-dropdown-panel .p-dropdown-items .p-dropdown-item{
    background: var(--blue-dark);
    }
.mimetika-dropdown-panel.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover,
.language-selector-panel.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover{
    color: var(--blue);
    border: none;
    box-shadow: none;
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/css/language-selector.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,UAAU;IACV,0BAA0B;AAC9B;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,qCAAqC,EAAE,6CAA6C;AACxF;;;AAGA;;IAEI,4BAA4B;IAC5B;AACJ;;IAEI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;AAC9B","sourcesContent":[".mimetika-login .language-selector{\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n}\n.language-selector .p-hidden-accessible {\n    display: none;\n}\n.language-dropdown {\n    padding: 5px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n}\n.language-selector .p-dropdown {\n    background: transparent;\n    border: none;\n}\n.language-selector .p-dropdown:hover span.p-dropdown-label{\n    opacity: 1;\n    text-decoration: underline;\n}\n.language-selector .p-dropdown span.p-dropdown-label {\n    padding: 0;\n    color: var(--blue);\n    opacity: 0.8;\n}\n.language-selector .p-dropdown .p-dropdown-trigger {\n    display: none !important;\n}\n.language-selector .p-dropdown:not(.p-disabled).p-focus{\n    box-shadow: none;\n}\n\n.mimetika-dropdown-panel.p-dropdown-panel,\n.language-selector-panel.p-dropdown-panel{\n    background: var(--blue-dark);\n    color: var(--gray);\n}\n.language-selector-panel.p-dropdown-panel {\n    transform: translateX(33%) !important; /* Mueve el panel hacia la izquierda un 50% */\n}\n\n\n.mimetika-dropdown-panel.p-dropdown-panel .p-dropdown-items .p-dropdown-item,\n.language-selector-panel.p-dropdown-panel .p-dropdown-items .p-dropdown-item{\n    background: var(--blue-dark);\n    }\n.mimetika-dropdown-panel.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover,\n.language-selector-panel.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover{\n    color: var(--blue);\n    border: none;\n    box-shadow: none;\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
